import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import { extendObservable } from 'mobx'
import { eplApi } from '@atheneum/api'
import debounce from 'lodash/debounce'

import Checkbox from '@components/Form/Checkbox'
import { Dropdown } from '@components/Form/Autocomplete'
import Input from '@components/Form/Input'
import InfoIcon from '@components/Icon/Info'
import Tooltip from '@components/Tooltip/Tooltip'

import './EplPaymentRates.sass'

class EplPaymentRatesForm extends Component {
  constructor(props) {
    super(props)
    extendObservable(this, {
      projectedMargin: 0.5,
      recommendedHonorarium: null
    })
    this.recalculateMargin()
  }
  static propTypes = {
    staticData: PropTypes.object,
    projectStore: PropTypes.object,
    form: PropTypes.object
  }

  renderMargin(margin) {
    if (!margin) {
      return <span>-</span>
    } else {
      const marginOk = margin >= 0.76
      return (
        <span>
          <span className={marginOk ? 'green-text' : 'red-text'}>
            {(margin * 100).toFixed(2)}%
          </span>{' '}
          <span>(Target 76%)</span>
        </span>
      )
    }
  }

  recalculateMargin = debounce(async () => {
    const margin = await eplApi.recalculateMargin(this.props.form.values)
    this.projectedMargin = margin.projectedMargin
    this.recommendedHonorarium =
      margin.recommendedHonorarium &&
      `${this.props.staticData.names.currencies[
      margin.recommendedHonorariumCurrencyId
      ]
      } ${margin.recommendedHonorarium}`
  }, 300)

  render() {
    const { staticData, projectStore, form } = this.props
    const honorariumCurrencyOptions = staticData.getHonorariumCurrencyOptions()

    return (
      <div className='epl-payment-rates__form actions'>
        <div className='actions'>
          <div className='epl-payment-rates__field actions__single'>
            <span className='epl-payment-rates__label actions__single__label'>
              Honorarium <strong>*</strong>
            </span>
            <div className='epl-payment-rates__group actions__single__value'>
              <div className='currency-input-wrapper currency-input-wrapper__epl-edit-modal'>
                <div className='currency-input-wrapper__select'>
                  <Field
                    name='honorariumCurrencyId'
                    placeholder='Currency'
                    options={honorariumCurrencyOptions}
                    itemToString={item => item && item.name}
                    disabled={form.values.free}
                    onChange={val => {
                      this.recalculateMargin()
                      form.setFieldValue('honorariumCurrencyId', val.id)
                    }}
                    component={Dropdown}
                    data-cy='honorarium-currency-dropdown'
                  />
                </div>
                <div className='currency-input-wrapper__value'>
                  <Field
                    name='honorarium'
                    placeholder='Amount'
                    disabled={form.values.free}
                    onChange={e => {
                      this.recalculateMargin()
                      form.setFieldValue('honorarium', e.target.value)
                    }}
                    component={Input}
                    data-cy='honorarium-amount'
                  />
                </div>
                <div className='currency-input-wrapper__help'>
                  <Field
                    name='free'
                    label='Free'
                    className='single__checkbox'
                    onChange={e => {
                      form.setFieldValue('free', !form.values.free)
                      form.setFieldTouched('free', true)

                      form.setFieldValue('honorariumCurrencyId', null, false)
                      form.setFieldValue('honorarium', '', false)
                    }}
                    component={Checkbox}
                  />
                  <Tooltip
                    tooltip={
                      'Check the box for ‘Free’ if Payment to Expert is not required.'
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='epl-payment-rates__field actions__single'>
            <span className='epl-payment-rates__label actions__single__label'>
              Fee <strong>*</strong> / Credits
            </span>
            <div className='epl-payment-rates__group actions__single__value'>
              <div className='currency-input-wrapper currency-input-wrapper__epl-edit-modal'>
                <div className='currency-input-wrapper__select'>
                  <Field
                    name='feeCurrencyId'
                    disabled={this.props.projectStore.isCreditBasedContract()}
                    placeholder='Currency'
                    onChange={val => {
                      this.recalculateMargin()
                      form.setFieldValue('credits', null)
                      form.setFieldValue('feeCurrencyId', val.id)
                    }}
                    title={
                      this.props.projectStore.isCreditBasedContract() &&
                      "You can't edit fee since applicable contract is credit based"
                    }
                    itemToString={item => item && item.name}
                    options={staticData.currencies}
                    component={Dropdown}
                    data-cy='fee-currency-dropdown'
                  />
                </div>
                <div className=''>
                  <Field
                    name='fee'
                    placeholder='Amount'
                    disabled={this.props.projectStore.isCreditBasedContract()}
                    component={Input}
                    onChange={e => {
                      this.recalculateMargin()
                      form.setFieldValue('credits', null)
                      form.setFieldValue('fee', e.target.value)
                    }}
                    title={
                      this.props.projectStore.isCreditBasedContract() &&
                      "You can't edit fee since applicable contract is credit based"
                    }
                    data-cy='fee-amount'
                  />
                </div>
                <div className='currency-input-wrapper__help'>
                  <Field
                    name='credits'
                    placeholder='Credits'
                    onChange={e => {
                      form.setFieldValue('credits', e.target.value)
                      form.setFieldValue(
                        'feeCurrencyId',
                        this.props.projectStore.applicableContracts[0]
                          .currencyId
                      )
                      form.setFieldValue(
                        'fee',
                        this.props.projectStore.applicableContracts[0]
                          .creditValue * e.target.value
                      )
                      form.setFieldValue('credits', e.target.value)
                      this.recalculateMargin()
                    }}
                    title={
                      !this.props.projectStore.isCreditBasedContract() &&
                      "You can't edit credits since applicable contract is not credit based"
                    }
                    className='additional-input'
                    disabled={!this.props.projectStore.isCreditBasedContract()}
                    component={Input}
                  />
                  <Tooltip
                    tooltip={
                      'Make sure to apply the correct pricing (Fee/Credits) as mentioned in the applicable Contract for this account.'
                    }
                    placement='top'
                  >
                    <div className='icon-wrapper'>
                      <InfoIcon />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          <div className='epl-payment-rates__field actions__single'>
            <span className='epl-payment-rates__label actions__single__label'>
              Pricing
            </span>
            <div className='epl-payment-rates__group--pricing actions__single__value actions__single__value--fullInput'>
              <Field
                name='pricingId'
                placeholder='Pricing'
                options={staticData.pricings}
                itemToString={item => item && item.name}
                component={Dropdown}
              />
            </div>
          </div>
          {!form.values.free && (
            <>
              <div style={{ paddingTop: 8 }}>
                {this.recommendedHonorarium && (
                  <span>
                    Recommended honorarium: {this.recommendedHonorarium}
                  </span>
                )}
                &nbsp;
              </div>
              <div style={{ paddingTop: 8 }}>
                {this.projectedMargin && (
                  <span>
                    Projected margin: {this.renderMargin(this.projectedMargin)}
                  </span>
                )}
                &nbsp;
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
}

export default inject('staticData')(observer(EplPaymentRatesForm))
